import { useI18n } from "../i18n/index.ts";

export interface PlacementBarProps {
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
}

/**
 * Barre du mode placement. Volontairement basse et courte : la carte doit rester
 * visible et manipulable pendant qu'on vise, c'est tout l'intérêt de déplacer la
 * carte sous un réticule fixe plutôt que de pointer du doigt — le doigt masque
 * la cible, le réticule non.
 */
export const PlacementBar = (props: PlacementBarProps): React.ReactElement => {
  const { t } = useI18n();

  return (
    <section className="placement" aria-label={t.placement.regionLabel}>
      <p className="placement__hint">
        <strong>{t.placement.title}</strong>
        <span>{t.placement.hint}</span>
      </p>

      <div className="placement__actions">
        <button type="button" className="button button--ghost" onClick={props.onCancel}>
          {t.placement.cancel}
        </button>
        <button type="button" className="button button--primary" onClick={props.onConfirm}>
          {t.placement.confirm}
        </button>
      </div>
    </section>
  );
};
